
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Clock } from "lucide-react";

interface VideoDurationFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function VideoDurationField({ value, onChange }: VideoDurationFieldProps) {
  return (
    <div>
      <Label htmlFor="video-duration">Διάρκεια Προβολής</Label>
      <div className="relative mt-1">
        <Clock className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input 
          id="video-duration"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="pl-10"
          placeholder="π.χ. 10:30"
        />
      </div>
    </div>
  );
}
